import { SET_TERMINAL_AUTH_DATA, SET_TERMINAL_BALANCE, SET_STARTUP_SETTINGS, LOGIN_ADMIN, SET_PROFILE_ERROR, SET_LANGUAGE, SET_BALANCE,
    CASHOUT_MONEY, CASHOUT_CLIENT_MONEY, CHANGE_SPORTSBOOK_LAYOUT, SET_CURRENCY, PRINT_TICKET, ADMIN_PAGE_EXIT, SHUT_DOWN, PRINT_LAST_TICKET,
    PRINT_LAST_CASH_OUT_TICKET, STACKER_COLLECTION, REBOOT_PC, OPEN_LAST_LOG_FILE, LAST_ENTERED_BILL_AND_COINS, NOTE_RECYCLER,
    LOCK_TERMINAL_ADMIN, UNLOCK_TERMINAL_ADMIN, RESET_BILL_ACCEPTOR, RESET_DEVICE_CONNECTION, CLOSE_APP_LOCATION,
    TODAYS_REPORT, REMOVE_STACKER_BALANCE, SHOW_STACKER_BALANCE, UPPER_SCREEN, TICKET_IN, TITO_ACCEPT_BET, TITO_CASHOUT_BET, GET_LAST_TICKETS, SHOW_LAST_BETS_LIST,
    TERMINAL_ERROR, SET_POPUP_LAUNCHER, TITO_ACCEPT_CASHOUT, LOCK_TERMINAL, UNLOCK_TERMINAL, HIDE_TERMINAL_ERROR, SEND_LOGS, SHOW_KEYBOARD,
    SET_TAX, USER_DID_LOGIN, USER_DID_LOGOUT, MOUSE_MOVE_POSITION, SHOW_DEVICE_STATUS, SET_HOPPER_1_VALUE, SET_HOPPER_2_VALUE, GET_LAST_TICKET_BY_ID, GET_LAST_PAYED_TICKETS,
    CHECK_HOPPERS_ERRORS_AND_STATES, HIDE_BETSLIP, SET_TERMINAL_ACUMULATOR_BONUSE, PRINT_LAST_PAYED_TICKETS, CLEAR_LAST_BETS_LIST, IS_ADMIN_LOGGED_IN, REGISTER_MODE,
    IS_CARD_REGISTERED, CONFIRM_REGISTRATION_NEW_CARD, ADD_TO_BALANCE, UPDATE_PLAYER_CARD_ID, CLEAR_CARD_REGISTERED, PRINT_LOTTERY_TICKET, LOYAL_CARD, PAY_CASINO_LOTTERY_WIN_TICKET,
    PRINT_BOOKING_TICKET, GET_SUPERBET_TICKET_BY_ID, SET_SUPERBET_ID, REJECT_SUPERBET, SUPERBET_IN_PROCESS, GET_BOOSTED_ODDS, CASINO_GAMES_OPENED,
    ADMIN_USER_COMMANDS, RFID_REGISTER_MODE, MULTIPLEDAYS_REPORT, SET_LOYAL_CARD_INPUT_ACTIVE, DEPOSIT, DEPOSIT_TO_CLIENT_ACCOUNT,
    PRINT_BET_BUILDER_TICKET, PRINT_CLIENT_TICKET } from "./actionTypes/index";

export const SetTerminalAuthData = (payload) => {
    return {
        type: SET_TERMINAL_AUTH_DATA,
        payload
    };
};

export const cardDepositMode = (payload) => ({
    type: DEPOSIT,
    payload
})

export const depositToClientAccount = (clientId) => ({
    type: DEPOSIT_TO_CLIENT_ACCOUNT,
    clientId
})

export const SetBonuses = (payload) => {
    return {
        type: SET_TERMINAL_ACUMULATOR_BONUSE,
        payload
    };
};
export const getBoostedOddsIds = (payload) => {
    return {
        type: GET_BOOSTED_ODDS,
        payload
    };
};
export const SetStartupSettings = (payload) => {
    return {
        type: SET_STARTUP_SETTINGS,
        payload
    };
};
export const HideBetslip = (payload) => {
    return {
        type: HIDE_BETSLIP,
        payload
    };
};
export const casinoGamesPageOpened = () => {
    return {
        type: CASINO_GAMES_OPENED,
    }
}

export const SetTerminalBalance = (payload) => {
    return {
        type: SET_TERMINAL_BALANCE,
        payload
    };
};

export const HandleMousePosition = (payload) => {
    return {
        type: MOUSE_MOVE_POSITION,
        payload
    };
};

export const UserDidLogin = (payload) => {
    return {
        type: USER_DID_LOGIN,
        payload
    };
};

export const UserDidLogOut = (payload) => {
    return {
        type: USER_DID_LOGOUT,
        payload
    };
};

export const LoginAdmin = (payload) => {
    return {
        type: LOGIN_ADMIN,
        payload
    };
};

export const SetTax = (payload) => {
    return {
        type: SET_TAX,
        payload
    };
};

export const UnlockTerminal = (payload) => {
    return {
        type: UNLOCK_TERMINAL,
        payload
    };
};

export const TitoAcceptCashout = (payload) => {
    return {
        type: TITO_ACCEPT_CASHOUT,
        payload
    };
};
export const RegisterMode = (payload) => {
    return {
        type: REGISTER_MODE,
        payload
    };
};

export const LockTerminal = (payload) => {
    return {
        type: LOCK_TERMINAL,
        payload
    };
};

export const SetTerminalPopupLauncher = (payload) => {
    return {
        type: SET_POPUP_LAUNCHER,
        payload
    };
};

export const TerminalError = (payload) => {
    return {
        type: TERMINAL_ERROR,
        payload
    };
};

export const HideTerminalError = (payload) => {
    return {
        type: HIDE_TERMINAL_ERROR,
        payload
    };
};

export const TitoAcceptBet = (payload) => {
    return {
        type: TITO_ACCEPT_BET,
        payload
    };
};

export const TitoCashoutAcceptBet = (payload) => {
    return {
        type: TITO_CASHOUT_BET,
        payload
    };
};

export const SetProfileError = (payload) => {
    return {
        type: SET_PROFILE_ERROR,
        payload
    };
};

export const SetLanguage = (payload) => {
    return {
        type: SET_LANGUAGE,
        payload
    };
};

export const SetBalance = (payload) => {
    return {
        type: SET_BALANCE,
        payload
    };
};

export const IsAdminLoggedIn = (payload) => {
    return {
        type: IS_ADMIN_LOGGED_IN,
        payload
    };
};

export const IsCardRegistered = (payload) => {
    return {
        type: IS_CARD_REGISTERED,
        payload
    };
};
export const ClearCardRegistered = (payload) => {
    return {
        type: CLEAR_CARD_REGISTERED,
        payload
    };
};
export const ConfirmRegistrationNewCard = (payload) => {
    return {
        type: CONFIRM_REGISTRATION_NEW_CARD,
        payload
    };
};
export const UpdatePlayerCardId = (payload) => {
    return {
        type: UPDATE_PLAYER_CARD_ID,
        payload
    };
};

export const CashoutMoney = (payload) => {
    return {
        type: CASHOUT_MONEY,
        payload
    };
};

export const PrintBookingTicket = (payload) => {
    return {
        type: PRINT_BOOKING_TICKET,
        payload
    };
};
export const NoteRecycle = (payload) => {
    return {
        type: NOTE_RECYCLER,
        payload
    };
};
export const CashoutClientMoney = (payload) => {
    return {
        type: CASHOUT_CLIENT_MONEY,
        payload
    };
};

export const ChangeSportsbookLayout = (payload) => {
    return {
        type: CHANGE_SPORTSBOOK_LAYOUT,
        payload
    };
};

export const SetCurrency = (payload) => {
    return {
        type: SET_CURRENCY,
        payload
    };
};

export const PrintTicket = (payload) => {
    return {
        type: PRINT_TICKET,
        payload
    };
};

export const PrintBetBuilderTicket = (payload) => {
    return {
        type: PRINT_BET_BUILDER_TICKET,
        payload
    };
};

export const PrintClientTicket = (payload) => {
    return {
        type: PRINT_CLIENT_TICKET,
        payload
    };
};

export const PrintLotteryTickets = (payload, isCopy) => {
    return {
        type: PRINT_LOTTERY_TICKET,
        payload,
        isCopy
    };
};

export const LoyalCard = (payload) => {
    return {
        type: LOYAL_CARD,
        payload
    };
};

export const SetLoyalCardInputActive = (isActive) => {
    return {
        type: SET_LOYAL_CARD_INPUT_ACTIVE,
        isActive
    };
};

export const GetLastTicketById = (payload) => {
    return {
        type: GET_LAST_TICKET_BY_ID,
        payload
    };
};
export const GetSuperbetTicketById = (payload) => {
    return {
        type: GET_SUPERBET_TICKET_BY_ID,
        payload
    };
};
export const SetSuperbetId = (payload) => {
    return {
        type: SET_SUPERBET_ID,
        payload
    };
};
export const RejectSuperbet = (payload) => {
    return {
        type: REJECT_SUPERBET,
        payload
    };
};
export const SuperbetInProcess = (payload) => {
    return {
        type: SUPERBET_IN_PROCESS,
        payload
    };
};

export const GetLastPayedTickets = (payload) => {
    return {
        type: GET_LAST_PAYED_TICKETS,
        payload
    };
};
export const PrintLastPayedTickets = (payload) => {
    return {
        type: PRINT_LAST_PAYED_TICKETS,
        payload
    };
};

export const AdminPageExit = (payload) => {
    return {
        type: ADMIN_PAGE_EXIT,
        payload
    };
};

export const ShutDown = (payload) => {
    return {
        type: SHUT_DOWN,
        payload
    };
};

export const PrintLastTicket = (payload) => {
    return {
        type: PRINT_LAST_TICKET,
        payload
    };
};

export const ShowLastBetsList = (payload) => {
    return {
        type: SHOW_LAST_BETS_LIST,
        payload
    };
};
export const ClearLastBetsList = (payload) => {
    return {
        type: CLEAR_LAST_BETS_LIST,
        payload
    };
};

export const PrintLastCashoutTicket = (payload) => {
    return {
        type: PRINT_LAST_CASH_OUT_TICKET,
        payload
    };
};

export const StackerCollection = (payload) => {
    return {
        type: STACKER_COLLECTION,
        payload
    };
};
export const addToBalance = (payload) => {
    return {
        type: ADD_TO_BALANCE,
        payload
    };
};
export const RebootPc = (payload) => {
    return {
        type: REBOOT_PC,
        payload
    };
};

export const OpenLastLogFile = (payload) => {
    return {
        type: OPEN_LAST_LOG_FILE,
        payload
    };
};

export const LastEnteredBillAndCoins = (payload) => {
    return {
        type: LAST_ENTERED_BILL_AND_COINS,
        payload
    };
};

export const LockTerminalAdmin = (payload) => {
    return {
        type: LOCK_TERMINAL_ADMIN,
        payload
    };
};

export const ShowKeyboard = (payload) => {
    return {
        type: SHOW_KEYBOARD,
        payload
    };
};

export const UnlockTerminalAdmin = (payload) => {
    return {
        type: UNLOCK_TERMINAL_ADMIN,
        payload
    };
};

export const ResetBillAcceptor = (payload) => {
    return {
        type: RESET_BILL_ACCEPTOR,
        payload
    };
};

export const ResetDeviceConnection = (payload) => {
    return {
        type: RESET_DEVICE_CONNECTION,
        payload
    };
};

export const CheckHoppersErrorsAndStates = (payload) => {
    return {
        type: CHECK_HOPPERS_ERRORS_AND_STATES,
        payload
    };
};

export const ShowDeviceStatus = (payload) => {
    return {
        type: SHOW_DEVICE_STATUS,
        payload
    };
};

export const CloseAppLocation = (payload) => {
    return {
        type: CLOSE_APP_LOCATION,
        payload
    };
};

export const SetTodaysReport = (payload) => {
    return {
        type: TODAYS_REPORT,
        payload
    };
};

export const SetMultipleDaysReport = (payload) => {
    return {
        type: MULTIPLEDAYS_REPORT,
        payload
    };
};

export const GetLastTickets = (payload) => {
    return {
        type: GET_LAST_TICKETS,
        payload
    };
};

export const SetHopper1Value = (payload) => {
    return {
        type: SET_HOPPER_1_VALUE,
        payload
    };
};

export const SetHopper2Value = (payload) => {
    return {
        type: SET_HOPPER_2_VALUE,
        payload
    };
};

export const RemoveStackerBalance = (payload) => {
    return {
        type: REMOVE_STACKER_BALANCE,
        payload
    };
};

export const ShowStackerBalance = (payload) => {
    return {
        type: SHOW_STACKER_BALANCE,
        payload
    };
};

export const UpperScreen = (payload) => {
    return {
        type: UPPER_SCREEN,
        payload
    };
};

export const TicketIn = (payload) => {
    return {
        type: TICKET_IN,
        payload
    };
};
export const PayCasinoLotteryWinTicket = (payload) => {
    return {
        type: PAY_CASINO_LOTTERY_WIN_TICKET,
        payload
    };
};
export const SendLogs = (payload) => {
    return {
        type: SEND_LOGS,
        payload
    };
};

export const AdminUserCommands = (command, payload) => ({
    type: ADMIN_USER_COMMANDS,
    command,
    payload
})

export const RfidRegisterMode = (mode, payload) => ({
    type: RFID_REGISTER_MODE,
    mode,
    payload
})
